import React, { useEffect, useState } from "react";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridNoRecords,
  GridColumn,
  GridCellProps,
} from "@progress/kendo-react-grid";
import { useOpenForCommentTableController } from "./OpenForCommentTableController";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@material-ui/core";
import { FilingLink } from "../../../../stateOffice/pages/FilingBuilder/components";
import { DraftPreviewModal } from "../../../../stateOffice/pages/WorkQueue/components/DraftPreviewModal";
import DescriptionIcon from "@material-ui/icons/Description";
import { Person } from "@material-ui/icons";
import { Link } from "react-router-dom";

interface IOpenForCommentTable {
  rows: any;
  columns: any;
  loading: boolean;
}

const OpenForCommentTable = (props: IOpenForCommentTable) => {
  const {
    // variable
    loading,
    rows,
    columns,
    dataState,
    dataResult,
    dialogOpen,
    proposedRuleData,
    alertMessage,
    alertOpen,
    // functions
    toggleDialog,
    dataStateChange,
    emailLiaison,
    toggleAlertDialog,
  } = useOpenForCommentTableController(props);

  const Draft = (data: GridCellProps) => {
    return (
      <td className="newIcon" role="gridcell">
        {data.dataItem.draftId ? (
          <div>
            <Button
              variant="text"
              color="default"
              onClick={() => toggleDialog(data.dataItem.draftId)}
              startIcon={<DescriptionIcon />}
            >
              View Proposed Rule
            </Button>
          </div>
        ) : null}
      </td>
    );
  };

  const Comment = (data: GridCellProps) => {
    return (
      <td className="newIcon" role="gridcell">
        <Button
          variant="text"
          color="primary"
          onClick={() => emailLiaison(data.dataItem.email)}
          startIcon={<Person />}
        >
          Leave Public Comment
        </Button>
      </td>
    );
  };

  return (
    <>
      {proposedRuleData ? (
        <DraftPreviewModal
          open={dialogOpen}
          close={toggleDialog}
          draftData={proposedRuleData}
        />
      ) : null}
      <Dialog
        open={alertOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="alert-dialog"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {alertMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button component={Link} to={"quicklinks"}>
            Go To Quicklinks Page
          </Button>
          <Button onClick={toggleAlertDialog}>Close</Button>
        </DialogActions>
      </Dialog>
      {rows.length > 0 ? (
        <Grid
          data={dataResult}
          sortable
          style={{ minHeight: "70dvh", height: "auto" }}
          pageable
          {...dataState}
          onDataStateChange={dataStateChange}
          filterable
        >
          <GridToolbar>
            <h3>Proposed Rules Open For Comment</h3>
          </GridToolbar>
          {columns ? (
            columns.map((element: any, i: number) => {
              if (element.hidden != true) {
                if (element.download == true) {
                  return (
                    <GridColumn
                      field={element.field}
                      key={element.title + i}
                      title={element.title}
                      cell={Draft}
                    />
                  );
                }
                if (element.field == "comment") {
                  return (
                    <GridColumn
                      field={element.field}
                      key={element.title + i}
                      title={element.title}
                      cell={Comment}
                    />
                  );
                } else {
                  return (
                    <GridColumn
                      field={element.field}
                      key={element.title + i}
                      title={element.title}
                    />
                  );
                }
              }
            })
          ) : (
            <CircularProgress />
          )}
        </Grid>
      ) : (
        <GridNoRecords>
          {props.loading ? <CircularProgress /> : "No records found"}
        </GridNoRecords>
      )}
    </>
  );
};

export default OpenForCommentTable;
